module.exports = __webpack_public_path__ + "img/like_dark.6ab27888.svg";